/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { ViewForm } from '@coursera/event-pulse-types';
import { useVisibilityTracker } from '@coursera/event-pulse/react';

type Props = React.PropsWithChildren<ViewForm['form']>;

export function ViewFormVisibilityTracker(props: Props) {
  const { children, ...form } = props;
  const ref: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker('view_form', {
    form,
  });
  return <div ref={ref}>{children}</div>;
}
